import angular from 'angular'
import { AccesoDatos } from './acceso-datos'
import { IAppStateConfig } from 'src/model/candidato-api'
import { BehaviorSubject } from 'rxjs'

export class AppConfigService {
  usercfg: IAppStateConfig

  $usercfg = new BehaviorSubject<IAppStateConfig | null>(null)

  constructor(private AccesoDatos: AccesoDatos) {}

  leerUserConfig() {
    return this.AccesoDatos.Login_CLIENT.userDetailsConConfig({ _cfg: { nogestionaerror: true } }).then((login) => {
      this.usercfg = login

      this.$usercfg.next(login)

      return login
    })
  }
}

angular.module('candidato').service('appConfigService', AppConfigService)
